<template>
  <div class = 'units-by-college'>
    <div class = 'unit-college'>{{ (college.values[0].values[0].college || {}).name }}</div>
    <div class = 'unit-items'>
      <program
        v-for = 'program in college.values'
        :program = 'program'
        :key = 'program.key'
      >
      </program>
    </div>
  </div>
</template>
<script>
import Program from './program.vue'

export default {
  props: ['college'],
  components: {
    Program
  }
}
</script>



// WEBPACK FOOTER //
// college.vue?0ddcadb3